import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    width: '100%',
    height: '100%',
    [theme.breakpoints.down('xs')]: {
      padding: 24,
    },
  },
  main: {
    width: 1000,
    maxWidth: '100%',
    height: 'auto',
    margin: 0,
  },
  bookingHeaderTitle: {
    marginTop: 8,
    marginBottom: 36,
  },
  agent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  avatar: {
    margin: '0 8px',
  },
}))
